import { Document, Page, Text, View, Font } from '@react-pdf/renderer';
import { ILead, ILeadReq } from '../models/BaseModel';
import styles from './NewItineraryStyle';
import { useState } from 'react';
import { Fetch } from './Fetch';
import { eachDayOfInterval, format } from 'date-fns';
import PdfHeader from './ResortInfo';
import { IAParamValue } from '../components/myLead/requirements/ActivityReq';

Font.register({
    family: 'Open Sans',
    src: 'https://fonts.gstatic.com/s/opensans/v27/mem8YaGs126MiZpBA-UFVZ0e.ttf',
});

interface Iprops {
    lead: ILead
    reqs: ILeadReq[]
}

const NewItineraryDocument: React.FC<Iprops> = ({ lead, reqs }) => {
    const getStayDates = (start: Date, end: Date) =>
        eachDayOfInterval({ start, end });

    return (
        <Document>
            <Page style={styles.page}>
                <PdfHeader />
                {reqs.map((req, i) => <View key={req.id}>
                    <Text style={styles.heading}>{i + 1}. Destination: {req.cityName}, {req.stateName}, {req.countryName}</Text>
                    <Text style={styles.heading}>Guest Details:</Text>
                    <View style={styles.tableHeader}>
                        <Text style={styles.column3}>Guest Name</Text>
                        <Text style={styles.column2}>Phone</Text>
                        <Text style={styles.column2}>Email ID</Text>
                        <Text style={styles.column}>Adult</Text>
                        <Text style={styles.column}>Child</Text>
                        <Text style={styles.column2}>Purpose</Text>
                    </View>
                    <View style={styles.tableRow}>
                        <Text style={styles.column3}>{lead.contactName}</Text>
                        <Text style={styles.column2}>{lead.contactContact}</Text>
                        <Text style={styles.column2}>{lead.contactEmail}</Text>
                        <Text style={styles.column}>{req.noOfAdults}</Text>
                        <Text style={styles.column}>{req.noOfChildren}</Text>
                        <Text style={styles.column2}>{req.purposeOfTripName}</Text>
                    </View>

                    <Text style={styles.heading}>Booking Details:</Text>
                    <View style={styles.tableHeader}>
                        <Text style={styles.column}>Check in Date</Text>
                        <Text style={styles.column}>Check in Time</Text>
                        <Text style={styles.column}>Check out Date</Text>
                        <Text style={styles.column}>Package</Text>
                        <Text style={styles.column}>Hotel</Text>
                        <Text style={styles.column}>Transport</Text>
                    </View>
                    <View style={styles.tableRow}>
                        <Text style={styles.column}>{format(new Date(req.checkin ?? ''), 'd MMM yyyy')}</Text>
                        <Text style={styles.column}>{format(new Date(req.checkin ?? ''), 'hh:mm a')}</Text>
                        <Text style={styles.column}>{format(new Date(req.checkout ?? ''), 'd MMM yyyy')}</Text>
                        <Text style={styles.column}>{req.packageName}</Text>
                        <Text style={styles.column}>{req.hotelName}</Text>
                        <Text style={styles.column}>{req.pickAndDrops && req.pickAndDrops.length > 0 ? 'Yes' : 'No'}</Text>
                    </View>

                    <Text style={styles.heading}>Room Details:</Text>
                    <View style={styles.tableHeader}>
                        <Text style={styles.column2}>Room Name</Text>
                        <Text style={styles.column}>Room Count</Text>
                        <Text style={styles.column}>Extra Mattress</Text>
                        <Text style={styles.column2}>Rate Plan</Text>
                    </View>
                    {req.rooms?.map(room =>
                        <View key={room.roomTypeId} style={styles.tableRow}>
                            <Text style={styles.column2}>{room.roomTypeName}</Text>
                            <Text style={styles.column}>{room.count}</Text>
                            <Text style={styles.column}>{room.mattress}</Text>
                            <Text style={styles.column2}>{`${room.price} rs/room + ${room.mattressPrice} rs/mattress`}</Text>
                        </View>
                    )}
                    {req.pickAndDrops && req.pickAndDrops.length > 0 &&
                        <>      <Text style={styles.heading}>Transport Details:</Text>
                            <View style={styles.tableHeader}>
                                <Text style={styles.column2}>Pickup Location</Text>
                                <Text style={styles.column}>Pickup Date</Text>
                                <Text style={styles.column}>Pickup Time</Text>
                                <Text style={styles.column}>Distance</Text>
                                <Text style={styles.column3}>Vehicle Name</Text>
                            </View>
                            {req.pickAndDrops?.map(pickAndDrop =>
                                <View key={pickAndDrop.id} style={styles.tableRow}>
                                    <Text style={styles.column2}>{pickAndDrop.pickupLocationName}</Text>
                                    <Text style={styles.column}>{format(new Date(pickAndDrop.time ?? ''), 'd MMM yyyy')}</Text>
                                    <Text style={styles.column}>{format(new Date(pickAndDrop.time ?? ''), 'hh:mm a')}</Text>
                                    <Text style={styles.column}>{pickAndDrop.distance} Km</Text>
                                    <Text style={styles.column3}>{pickAndDrop.vehicles?.map(v =>
                                        `${v.vehicleTypeName} x ${v.count}`
                                    ).join(', ')}</Text>
                                </View>
                            )}
                        </>}

                    {req.activityTypes && req.activityTypes.map(at => {
                        const groupedByAcivityId = at.reqParamsValue?.reduce((acc: Record<number, IAParamValue[]>, item) => {
                            if (!acc[item.activityId]) acc[item.activityId] = [];
                            acc[item.activityId].push(item);
                            return acc;
                        }, {});
                        return <View key={at.activityTypeId}>
                            <Text style={styles.heading}>{at.activityTypeName} Details:</Text>

                            {groupedByAcivityId && Object.keys(groupedByAcivityId).map((activityIdStr, i) => {
                                const activityId = parseInt(activityIdStr);
                                return <View key={activityId}>
                                    <Text style={styles.subHeading}>{i + 1}. {req.itinerary?.find(f => f.activityId === activityId)?.name}</Text>
                                    {/* {(() => {
                                        return at.activityParamsValue?.find(f => f.activityId === activityId)?.paramsValue.map(p =>
                                            <View key={p.paramId} style={styles.dataView}>
                                                <Text style={styles.dataHead}>{p.name}</Text>
                                                <Text style={styles.dataPara}>{p.value}</Text>
                                            </View>
                                        );
                                    })()} */}
                                    {groupedByAcivityId[activityId].map(p =>
                                        <View key={p.paramId} style={styles.dataView}>
                                            <Text style={styles.dataHead}>{p.name}</Text>
                                            <Text style={styles.dataPara}>{p.value}</Text>
                                        </View>
                                    )}
                                </View>
                            })}
                        </View>
                    })}

                    <Text style={styles.heading}>Details of Itinerary: {req.packageName}</Text>
                    {req.checkin && req.checkout && (() => {
                        const dates = getStayDates(new Date(req.checkin), new Date(req.checkout));
                        return <>{dates.map((day, i) => (
                            <View key={i} style={{ marginBottom: 30 }}>
                                <View style={styles.tableHeader}>
                                    <Text style={styles.column}>Days#</Text>
                                    <Text style={styles.column}>Date</Text>
                                    <Text style={styles.column}>Day</Text>
                                    <Text style={styles.column}>Activities#</Text>
                                </View>
                                <View style={{ ...styles.tableRow, marginBottom: 20 }}>
                                    <Text style={styles.column}> {i + 1}</Text>
                                    <Text style={styles.column}>{format(day, 'd MMM yyyy')}</Text>
                                    <Text style={styles.column}>{format(day, 'EEEE')}</Text>
                                    <Text style={styles.column}></Text>
                                </View>

                                <View style={styles.tableHeader}>
                                    <Text style={styles.column}>Time</Text>
                                    <Text style={styles.column9}>Activity</Text>
                                </View>
                                {req.itinerary?.filter(a => a.isIncluded && a.startTime > ((i) * (60 * 24)) && a.startTime < ((i + 1) * (60 * 24)))
                                    .sort((a, b) => (a.startTime) - (b.startTime)).map((a, _i) => {
                                        return <View key={_i} style={styles.tableRow}>
                                            <Text style={styles.column}>{(() => {
                                                const hours = Math.floor(a.startTime / 60);
                                                const mins = a.startTime % 60;
                                                const date = (new Date()).setHours(hours, mins, 0, 0);
                                                return format(date, 'hh:mm a');
                                            })()}</Text>
                                            <Text style={styles.column9}>{a.name}{a.desc ? ` | ${a.desc}` : ''}</Text>
                                        </View>
                                    })}
                            </View>
                        ))}</>
                    })()}

                    <PdfHeader />
                </View>)}
            </Page>
        </Document >
    );
};

export default NewItineraryDocument;
